// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content div.upload-media-buttons-group {
  text-align: center;
}
ion-content ion-thumbnail {
  height: 25px;
  width: 25px;
}`, "",{"version":3,"sources":["webpack://./src/app/shared-styles/upload-media-buttons.scss"],"names":[],"mappings":"AACE;EACE,kBAAA;AAAJ;AAGE;EACE,YAAA;EACA,WAAA;AADJ","sourcesContent":["ion-content {\r\n  div.upload-media-buttons-group {\r\n    text-align: center;\r\n  }\r\n\r\n  ion-thumbnail {\r\n    height: 25px;\r\n    width: 25px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
